import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const FacultyMemberSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("facultyMemberSelect", true))
);

export default FacultyMemberSelectMultipleTester;
